import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { IncomingMessage, ServerResponse } from 'http'
import { ServerExperiments } from '@/experimentation'
import { ExperimentParamsArray, runExperimentsOnServer } from '@/experimentation/server'
import { getGuildStatus } from '@/services/GuildUserService'
import { getEmptyGuildStatus, GuildStatus } from '@/utils/users/usersServer'

/**
 * First variation of features on Gift the Guild.
 *
 * We aren't showing variations to non-logged in, non-Guild Members. The reason is that
 * we have an open landing page now. This restriction allows us to avoid having two
 * growthbook experiments -- one anonymous and one for logged-in userId. In other words,
 * non-Guild Members will not see any of these variations.
 */
export async function runGuildGiftFeatures2Experiment({
  guildStatus: guildStatusProps,
  client,
  req,
  res,
}: {
  guildStatus?: GuildStatus
  client: ApolloClient<NormalizedCacheObject>
  req: IncomingMessage & { cookies: Partial<{ [p: string]: string }> }
  res: ServerResponse
}): Promise<{ guildStatus: GuildStatus; experiments: ServerExperiments }> {
  const baseExpConfigs: ExperimentParamsArray = [{ experimentKey: 'gift-guild-features-2', defaultValue: 'off' }]

  const isNotAMemberAlreadyQueried = !!guildStatusProps && !guildStatusProps.isGuildMember
  if (isNotAMemberAlreadyQueried) {
    return { guildStatus: getEmptyGuildStatus(), experiments: mapExperimentsOff(baseExpConfigs) }
  }

  const guildStatus = guildStatusProps ? guildStatusProps : await getGuildStatus(client)
  const isNotAMemberAfterQuery = !guildStatus?.isGuildMember
  if (isNotAMemberAfterQuery) {
    return { guildStatus: getEmptyGuildStatus(), experiments: mapExperimentsOff(baseExpConfigs) }
  }

  const experiments = await runExperimentsOnServer(req, res, baseExpConfigs)
  return { guildStatus, experiments }

  function mapExperimentsOff(params: ExperimentParamsArray): ServerExperiments {
    return Object.fromEntries(params.map((param) => [param.experimentKey, param.defaultValue])) as ServerExperiments
  }
}

export function isGiftGuildFeatures2ExperimentOn(experiments: Partial<ServerExperiments>) {
  return experiments['gift-guild-features-2'] === 'on'
}
